/**
 * Lifestyle photos of the home page.
 *
 * To add a photo: drop the file in src/assets/photos/ (square, 1200 x 1200, WebP, under 150 Ko),
 * import it here and set it as `src`. While `src` is null the slot shows its `idea` as a placeholder,
 * with the app mini-card already layered on top, so nothing else needs to change.
 *
 *   import budgetPhoto from "../assets/photos/budget.webp";
 *   budget: { src: budgetPhoto, ... }
 */
import budgetPhoto from "../assets/photos/budget.webp";
import categoriesPhoto from "../assets/photos/categories.webp";
import goalsPhoto from "../assets/photos/goals.webp";
import patrimoinePhoto from "../assets/photos/patrimoine.webp";
import storyPhoto from "../assets/photos/story.webp";

export const photos = {
  budget: {
    src: budgetPhoto,
    alt: "Une personne qui paie en terrasse, sereine",
    idea: "Quelqu'un de 25-35 ans en terrasse qui paie son café avec son téléphone, détendu. L'idée : dépenser sans stress.",
  },
  categories: {
    src: categoriesPhoto,
    alt: "Une personne dans son canapé, téléphone en main",
    idea: "Une personne dans son canapé en fin de journée, téléphone en main, lumière chaude. L'idée : ça se fait tout seul.",
  },
  goals: {
    src: goalsPhoto,
    alt: "Deux personnes en voyage devant un paysage",
    idea: "Un couple ou deux amis en rando ou en voyage, vue dégagée. L'idée : le projet qu'on finance.",
  },
  patrimoine: {
    src: patrimoinePhoto,
    alt: "Une personne concentrée devant son ordinateur à la maison",
    idea: "Une personne de 30-35 ans à son bureau à la maison, concentrée et sereine. L'idée : construire sur la durée.",
  },
  // About page
  story: {
    src: storyPhoto,
    alt: "Michael en séance de coaching financier",
    idea: "Une vraie photo de Michael en séance de coaching : deux personnes à une table, un ordinateur ouvert, ambiance détendue. L'idée : l'humain avant l'app.",
  },
};
